import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { MovieCard } from "@/components/MovieCard";
import { Bookmark } from "lucide-react";

const MyList = () => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/mylist")
      .then((r) => setMovies(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#030303] pt-24 pb-20 px-4 sm:px-8 max-w-[1600px] mx-auto">
      <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tighter text-white mb-8">My List</h1>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="w-10 h-10 rounded-full border-2 border-white/10 border-t-[#00F0FF] animate-spin" />
        </div>
      ) : movies.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="mylist-empty">
          <Bookmark size={48} className="text-white/20 mb-4" />
          <p className="text-white/60 mb-6">Your list is empty. Add titles you want to watch later.</p>
          <Link to="/browse" className="rounded-full bg-[#00F0FF] text-black font-semibold px-6 py-2.5 hover:scale-105 transition-transform">Browse Catalogue</Link>
        </div>
      ) : (
        <div className="grid gap-4 sm:gap-6" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))" }} data-testid="mylist-grid">
          {movies.map((m) => (
            <div key={m.id} className="[&>a]:!w-full">
              <MovieCard movie={m} testid={`mylist-card-${m.id}`} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyList;
